import { render, staticRenderFns } from "./addFundDialog.vue?vue&type=template&id=4a4bb2b2&scoped=true&"
import script from "./addFundDialog.vue?vue&type=script&lang=js&"
export * from "./addFundDialog.vue?vue&type=script&lang=js&"
import style0 from "./addFundDialog.vue?vue&type=style&index=0&id=4a4bb2b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4bb2b2",
  null
  
)

export default component.exports